export const getFullPageLoaderLoading = state => {
  return state.fullPageLoader.loading;
};
